<i18n>
{
  "en": {
    "access": {
      "denied": "You do not have sufficient permissions to take this action"
    }
  }
}
</i18n>

<template>
  <div class="permissions">
    {{ $t('access.denied') }}
  </div>
</template>

<script>
export default {
  name: 'permissions',
};
</script>
